export default "__VITE_ASSET__OIQeZwft__"